var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowToReg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_148_693",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0332031,
    y: 0.585327,
    width: 49.1933,
    height: 49.1933,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_148_693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6493 41.6891L25.2874 35.3272L27.4474 33.1671L31.6493 37.369L42.0004 27.018L44.1604 29.178L31.6493 41.6891ZM20.4705 24.5503C18.4976 24.5503 16.8088 23.8479 15.4039 22.443C13.999 21.0381 13.2965 19.3492 13.2965 17.3764C13.2965 15.4035 13.999 13.7146 15.4039 12.3098C16.8088 10.9048 18.4976 10.2024 20.4705 10.2024C22.4433 10.2024 24.1322 10.9048 25.5371 12.3098C26.942 13.7146 27.6444 15.4035 27.6444 17.3764C27.6444 19.3492 26.942 21.0381 25.5371 22.443C24.1322 23.8479 22.4433 24.5503 20.4705 24.5503ZM25.7997 28.3582L18.8307 35.3272L23.6829 40.1597H5.09766V35.6031C5.09766 34.5151 5.3716 33.5645 5.91949 32.7512C6.46738 31.9379 7.19464 31.3013 8.10127 30.8415C9.84353 29.9532 11.683 29.2345 13.6197 28.6853C15.5564 28.1361 17.84 27.8615 20.4705 27.8615C21.4953 27.8615 22.4486 27.9029 23.3302 27.9857C24.2119 28.0685 25.035 28.1926 25.7997 28.3582Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToReg);
export default __webpack_public_path__ + "static/media/how_to_reg.384d4c02e93c4eb77bad2d24a7b35f68.svg";
export { ForwardRef as ReactComponent };